// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  academyCategories: 'fb670d0a0bce7a40e6d3e1866599b496',
  academyCourses: 'daa590ef35214f5e040f2bd6ee34412a',
  academyInstructors: '6f4a29e8301b4de6ba957be8a227331b',
  academyLessons: 'def9dd292a20a515a8e833080e617979',
  academyModules: 'db5a8b4e3d5d31db4f7706783b6e3d40',
  academyPriceTiers: '8f9b15b484a31e0d60ea7001b3c61961',
  accountProgress: '3688d6e7dc0acbb3fa916977d4639d93',
  agents: '8e5f27e712326907fda0ce51052dadd7',
  agentSessions: '13b01d7a678c79e730b06b05e5cfecc5',
  allProjects: '874cd197433ea966a2eb8a37fa6a7108',
  applicationScopes: '9947a1a7d3aef85aebd2999eac5c31b8',
  articles: '21e2a589930880b02849c0d5cd1784c6',
  banners: 'c6b9a00c17fc9b35fc4b755e7325f842',
  bidAwardRevokeReasons: '64acf7c4c868f9dbcb96f165f6152f33',
  bidBuyerProjectFees: '1fe413c25bf07f0f2c6c9a525a43b20d',
  bidEditRequests: '3adb4df25e6f2abbe24ddd9c4782d4a4',
  bidRatings: '79165c6e4378ec4106df9d0e76daeb3e',
  bids: '296b6131ad2321baae94c26349722008',
  bidSummaries: '7d5ace0b55b64e31fa94713422e25ab0',
  bidUpgradeFees: '4579a27fe5872b4df1b9cf24f9c53d57',
  billingAgreements: '6aff8760dae9a8c9b439ce3ba1f2919c',
  canViewEmployerProfile: 'e4cd062351bbdf3e5ac60870fc756d88',
  cartItems: 'd7e644ef2b74da6880c36c9077117702',
  carts: '04dab66fc081c92d5a5e263d3514911d',
  categoryPageViewUsers: 'e6bbf42b05c80af0645ab087f129baa0',
  certifications: '43fd8862311f73a91a22f2e897799065',
  contacts: '83a94132b4b6a23ce3c35ce9d41b6110',
  contestBudgetRanges: '68ec769e2457359239fdcc61ad36f041',
  contestComments: '6e9d4f72d9870a4c7f46e6da3c05a1d4',
  contestEngagement: 'a5593474fb4fe13cf7ff54a2b5dcacda',
  contestEntries: '9fc5f8a3bc62bac260b86749b1c8c1eb',
  contestEntryMessages: 'e2fad05ae50e5b9230c940c76ac6c7ad',
  contestFees: '12a03576c5a766a03818e2a660483e90',
  contestFiles: 'abe08370d1fcbb188064e2fc20abf5f7',
  contestHandovers: '9ac9b70b0f42d6f0f2f079df0e8437ce',
  contestHasInvoices: 'da0535723aa640de1eae01ebdd336341',
  contestInterestedFreelancers: 'c43f3df6657d87978a841360838e64d2',
  contestMessages: '577f0a92c4c80c389738bdeb61fe2aa1',
  contestMinimumBudgetClassifications: '5927f1833074f51a601116d91011d5e1',
  contestQuickviewEntries: '03b2af321037d912ef7bf23307d2d407',
  contests: '5673a8794d75b6f0dec4565666e10b5d',
  contestViewContests: '3af2a3d9ee94b87d70b7deb1f9613d8b',
  contestViewEntries: '246b3ab836b55ac22a3a3b75ee07de3c',
  contestViewEntryIds: '7e381241e5150beae941dbab2fd79250',
  contestViewNewOrUpdatedEntries: '62b044801e8c0866983e8371ee004aef',
  countries: '33e3d762aebe1f0623085e309dd09ee8',
  currencies: '7de9b2df5bf61db45209b0276ae15363',
  currenciesIncludingExternal: '7de9b2df5bf61db45209b0276ae15363',
  dashboardPolls: '4a5ec8404c9cc72f492206255a087633',
  dashboardWidgets: '47db5a7df92772b22a46b9a35aff6594',
  deloitteSubscriberEmails: '1c0091df229fdc72087ecdc965f702a0',
  deloitteUserInfo: '6f940769d6f4aad061a8ffae7ad86b63',
  depositFees: '85dc2b2a2031be813a9643266a4dd010',
  depositPageVars: '10745ad12dfa11c2d7857d8c38cd00ee',
  developerApplications: '937e94bb45e2b2d0c548490d1e4237a9',
  developerTokens: 'ae77f04e1068b8e15782e70604eceda3',
  discoverCollectionItems: 'd49ecd957990be88a5c0146f9b819efc',
  discoverCollections: 'f3e5816f6210bed2525a5024155dd4ec',
  domains: 'c0e06272e05d594cf6702b5419ed5243',
  driveFilePermissions: 'c0cff6c7d2029832d4642533a723540d',
  driveFiles: '724a2a8039a094de4f884ff49b4df8e3',
  educations: '8e7f7e3d902633deb708d813bb61e9dc',
  emailIsAvailableForArrow: 'a0ddf5b621669626a62f47df472f3a87',
  employerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  encodedUrl: 'a86dacdcfe22e36258a0ec0a180fcd6f',
  equipment: '401a6e037ec2892bf5110d5e3795d3a8',
  exchangeRates: 'f83b34c90a913ca6e474c7386150b771',
  experiences: '40986fee31964385e45bc33aef538cf7',
  freelancerReputations: '3cebc056801046cf1be2c88ddc8d791d',
  freelancerReputationsRehireRates: '3cebc056801046cf1be2c88ddc8d791d',
  grants: '20ff455821752fb9663d8e5132ecb5cf',
  hiremeCounteroffers: '01f09946ca292605b754886da54f72cf',
  hourlyContracts: '81b362465ff0f0e19ee711f118ac5791',
  hourlyProjectMilestoneFees: '06d688f2a842f625af0fb0e8fa3c9b30',
  invoices: 'd0fc4cd9c09cc18075303cd8968637c3',
  ipContracts: 'b4a6b468834bdbcf9db8cb825d8913f2',
  issuingInstitution: '95b335961666b09b4cf2b3207794d307',
  jobClassifier: 'be13e9b8247389acf7d14f58d02098f6',
  languageDetect: '8396cfb5cbcb3c8df3a922741007716c',
  languages: 'b5e1f3de9dae5b4c1526d475397a9bcd',
  membershipBenefits: '35e0ee8c6f67d33168c1cdb83aa7e531',
  membershipDowngrades: '5e55af3581868b7b8e293b90768eadb8',
  membershipSubscriptions: '0c4efaf0be704e7d0f20a57f3a6fade5',
  messageAttachments: '651faffef24bfb290da9076ef4094f1e',
  messages: '14aa051fb6cd5bd2b98ee923d9aa98f3',
  milestoneDrafts: 'f11b88854b984bd391b567b18c3af8ed',
  milestoneRequests: '4a03ed6f70c6e69c43377c1555c84e45',
  milestones: '24c12b0c39c447c4cfb5dce90172f4ac',
  modifyBidSellerFees: '403c3613ac89c1de9cf84c3c7455df3e',
  nativeExchangeRates: 'f83b34c90a913ca6e474c7386150b771',
  nearbyProjects: '38cd7a0997c782632c26a6078ec8a735',
  newsfeed: 'e30e8d75e9d468e115d21a7e30e86283',
  nextPreviousUsers: '7b59c6479775e199046719f3797eb497',
  notifications: 'dbe9378b08786363e471bcc3bc576826',
  notificationsPreferences: '707e41567df79de7d3093d607f53368a',
  onBehalfProjects: '4e0e81938a24131a4a2d84d7591bdbd6',
  onlineOffline: 'c8e6e68cd993759dac49382b61a1ac64',
  pfSupportTickets: '1c736a0679b47a2f92fee2888149c236',
  pjpAssistantEnqueue: '9d60ace685ca5972b1967be2059d8bcc',
  portfolios: 'fe42028611261ddfc59c915fd39f51e4',
  postJobPageFormState: '85ebe427e789d81ca4c442f74bd95c3d',
  predictedSkills: '724d5f18f98df47a7253837e1d03c9a6',
  profileCategories: '6e2e5dd8262e1e3a576a232c5d674ada',
  profileViewUsers: '8f212f094325dd72911bdefb86a6a29a',
  projectBidInfo: '593d90fa6eef95999b6e1de279c63fd2',
  projectBookmarks: '94b358c99f7d89310f719640a163581c',
  projectBudgetOptions: 'fe3aa365c616fb43e1da48afcc2f130d',
  projectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  projectFeed: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeedFailingContests: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeedFailingProjects: 'ebfb0b0cc6c9f19952c84352c84b969c',
  projectFeeInfo: '141ae845bb7bcbec6f8b1c39d825b7f2',
  projectInvite: 'e0d5e878b75f9ffb0d4a185d388b6030',
  projectOffer: '7f26ad3000909c270de718570960cc58',
  projects: '988028e4eba765527b335c92b70c7af6',
  projectStats: '9445ad19188c72c9c47d31367736ab61',
  projectUpgradeFees: 'c27fba41135062d4cc8346458f1d85c2',
  projectViewBids: 'a318f16cc0c25e4a9595969adffc4f2f',
  projectViewProjects: '548ab0d65d78fdcce15651ce6dd92c75',
  projectViewUsers: 'd533b00faa9bb3d3db543b85acabcc1d',
  publications: '32798a1bbd15853ddb6ec4f76fa43f97',
  recommendedMembership: '639af6e0ad703937a10cf2ed5a34d11e',
  recommendedUsernames: 'c1730888439c6e53b0b7c05b9e7edef2',
  recruiterOptOut: 'f7106ebbf3e60c1a6fa980bcf70ae004',
  referralInvitationCheck: '24eddef86909e002dd9ee8cded56f8d2',
  referralInvitations: '61348e34ac68a8f8c437f8d0f33eddf9',
  userRequiresGdpr: '1f1923492a3b9ecbd2ce5b3c9c9d1b28',
  reviews: 'bf070f7af04c0047f56f08b7a7b92e46',
  reviewsSkills: '0fa5a9706cd3dde5679039085018d7de',
  searchActiveProjects: '76f985cae1aba070dc48d29c2b694a3c',
  searchContests: '4eecae75511f66bd3a1d7abbad095059',
  searchContestEntrants: '16c81d21c56d0f1b5ec1929be770feae',
  searchContestEntries: '246b3ab836b55ac22a3a3b75ee07de3c',
  searchFreelancers: '59790ae02045d1b1a8fcd4eb0284fd9d',
  searchHistory: '7a826dfd6e549968829c4e407125bb5d',
  searchKeywordProjects: '8f473759d5ec350feba69f442c5952cd',
  searchMyContacts: 'e62414e4cf126c78a96d0bd3b10ac132',
  searchMyProjectsBuyer: 'c1c4c45e381ac26d2254b5cb5afa7f23',
  searchThreads: 'ae15f97f2addb674ad5625424d99e907',
  searchUsers: '5803d3fb083f77c2324c82efe20d15a6',
  showcase: '0c981d301c5de4580dc57660f05ac84d',
  showcaseSource: '528a53ba8ced968954a3585a5225a22c',
  similarFreelancers: 'a94c2497773696df7c26be74e2ff7530',
  similarShowcases: 'a94c2497773696df7c26be74e2ff7530',
  siteStats: '95a8af1926677fb0ed9b8a1de744dd5d',
  skills: 'b0b9d47616e234db600127beb4ebf884',
  suggestedSkills: '74db00b149426fa76661ddd86621e02d',
  superuserAgentSessions: '13b01d7a678c79e730b06b05e5cfecc5',
  superuserBids: '296b6131ad2321baae94c26349722008',
  superuserMessages: '14aa051fb6cd5bd2b98ee923d9aa98f3',
  superuserMilestones: '24c12b0c39c447c4cfb5dce90172f4ac',
  superuserProjectCollaborations: '47de2c84d4c059dbd46a9e54f2e8b465',
  superuserProjectViewProjects: '548ab0d65d78fdcce15651ce6dd92c75',
  superuserThreads: '31d0eca5cadc85df4899a966e7ac33bf',
  superuserProjectViewUsers: 'a042d8f12799fe4afedaee91350b5022',
  tagFamilyMembers: 'bec8b904ff3c95ce66f8f068ad560215',
  tagProperties: 'c921ffb9aa46d085b4828622489c8d71',
  tags: 'bcf4ea4b24fd7c420e375e6a3e865817',
  tasks: '01c5cb8d0996464fe2f088daf4d4e359',
  tax: '09e8975a9499f263c33cb9db2747c307',
  teamMembers: 'bb6a0e0816be6616cd7e94e9d7cb3386',
  teams: '2683231453ddb11b5b8781fbae14592a',
  testing: '256627261e4240c902d28f33d754e3f9',
  threadProjects: '615c3c9dc5fca61a842ba0be13e9f65d',
  threads: 'ae15f97f2addb674ad5625424d99e907',
  threadUsers: '6cd9b64db2d400c4ebe9df976d00a42a',
  timeTrackingDailyAggregates: 'cf0b1a2d3b1818f710fd8b075d328e75',
  timeTrackingPunches: 'a86fa2830faaceb3958281ddcd8da60e',
  timeTrackingSession: 'afd7dcc3791c3071706c3f11df175ed9',
  timeTrackingSessionAggregate: 'c21f646077e99cb71252ac21e55dab7e',
  toastNotifications: '4c8d6c5d635afe514ec130762337e197',
  topSkills: '88edbb1b65d6031c7e16fea85f5e9c86',
  tracks: 'e432997983ba0bedffd22d84f0d1e939',
  transactionHistoryDetails: '2c9bcefdc7a6d4094ed734f28c4ca093',
  transactionHistoryItems: '584221b11640fef828f038a3bcd4d357',
  twoFactorDetails: 'bf5a516c4382437117e334903aaeae3c',
  universities: '6864ec0a4d30b810ff1df4e3433ea339',
  userBalances: 'ac222b4645e3d514e8b493905d12f8f1',
  userBidLimit: 'bbd8ee874d96afa7257b9e5dd2604c55',
  userCalifornianStatuses: '811b21828faa5a88aee50fa30d9cfc63',
  userDepositMethods: 'f49d9cf97d9c96227a57a4a3a6d997bf',
  userGiveGetDetails: 'd111cdcfd30887f43734ba920b81f71e',
  userHasGivenFeedback: '9da27991064a86ae00666fdfb61bf052',
  userInfo: 'a4ef52f47c0add4c2da46fc0e0d7e2a0',
  userInsignias: 'e393f744166ee2426b598923634c9f7e',
  userInteractions: 'b69a5eaa43726f0eae83d0348f44abf6',
  userIsArrowWhitelisted: 'd57f78c922d51723060e1b7efc222273',
  userOnPaytmMembershipPlan: '41cbb1f644ef5ec65b4c7216aac23311',
  userPendingFunds: 'af370a4b7c2adb028a666297aa9ffa28',
  userRecentProjectsAndContests: 'ea394addcb61da312db4ff899767f57d',
  users: '6cd9b64db2d400c4ebe9df976d00a42a',
  userSkills: 'e25b853ca911f12c0be653aa7a70b706',
  userTypeInfo: '946dad862050d0198174c3380eb7e91f',
  usersFollow: 'bbea0e01511c4dca66ded193ee07fca0',
  usersLocation: '36c37e6fe4dfd1b3f46b2108585890a0',
  usersProfile: 'e64af88a34b1c8a8980e733421c87b42',
  usersProfileImage: 'e97d332d6bb3ee806476de0483c34df7',
  usersRecommend: '0a80e5d13a75c26e4e765d9042d3acb6',
  usersSelf: '048e8ed7d2a9cce9823634e61e1def61',
  usStates: 'f251a17954a572d64b9400e2e94b9ded',
  verificationAddressDocumentTypes: 'd13b03dc042b753ecea9437010ac4ff8',
  verificationFiles: '95b77192f8e35b2ccc158a8d494b723d',
  verificationIdTypes: '70151aa0c0c75979b269082909b8bf3f',
  verificationRequest: '3248577d843c61f41b4233ded4f38eed',
  violationReports: 'dbfad1ca25a7e3cc8ee195731a134564',
  webhooks: 'cada0b9dbf7f2dedb9f053882b7d0f87',
};
